import type { Options, VirtualElement } from '@popperjs/core';
import type { Modifier } from 'react-popper';
import { usePopper as useReactPopper } from 'react-popper';

import { createMeasurablePopper } from './measurablePopper';

type UsePopperOptions<Modifiers> = Omit<Partial<Options>, 'modifiers'> & {
  createPopper?: typeof createMeasurablePopper;
  modifiers?: ReadonlyArray<Modifier<Modifiers>>;
};

/**
 * `react-popper`'s hook, building every popper instance through
 *  `createMeasurablePopper` so a deferred reposition cannot crash on a document
 *  that has gone away.
 */
export function usePopper<Modifiers>(
  referenceElement?: Element | VirtualElement | null,
  popperElement?: HTMLElement | null,
  options?: UsePopperOptions<Modifiers>
) {
  return useReactPopper<Modifiers>(referenceElement, popperElement, {
    ...options,
    createPopper: options?.createPopper ?? createMeasurablePopper,
  });
}
